import { motion } from "framer-motion";
interface CTAButtonProps {
  label?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}

/** Botón de compra: siempre lleva a la sección de compra (#compra). */
export function CTAButton({
  label = "Quiero mejorar mi mentalidad",
  onClick,
  className = "",
  fullWidth = true
}: CTAButtonProps) {
  const goToCompra = () => {
    if (onClick) return onClick();
    const el = document.getElementById("compra");
    if (el) el.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <motion.button type="button" onClick={goToCompra} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.03, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut"
  }} className={`${fullWidth ? "w-full" : ""} rounded-2xl bg-blue-700 px-6 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-blue-700/30 transition-colors hover:bg-blue-800 active:bg-blue-900 ${className}`} data-id="element-97" data-mp="2ozzy4ktui44l">
      {label}
    </motion.button>;
}